// src/config/about/assets.js

const img = (name) => require(`@/assets/placeholders/${name}`);

const plant = (i) => ({
  large: img(`plant_${i}.webp`),
  largeMobile: img(`plant_${i}_mobile.webp`),
  small: img(`plant_${i}_small.webp`),
  smallMobile: img(`plant_${i}_mobile_small.webp`),
  title: "",
});

export const aboutAssets = {
  factoryGallery: [
    plant(1),
    plant(2),
    plant(3),
    plant(4),
    plant(5),
    plant(6),
    plant(7),
  ],

  introVideo: {
    desktop: img("shixiao.mp4"),
    mobile: img("shixiao_mobile.mp4"),
    posterDesktop: img("shixiao_poster.jpg"),
    posterMobile: img("shixiao_mobile_poster.jpg"),
  },
};
